module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/companies/companies.component.scss
// module id = 579
// module chunks = 1